import FontBody2 from '../../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR } from '../../../../../../components/fonts/font-props';
import './tooltip-info-layout.scss';

interface IProps {
    children: React.ReactNode[];
}

const TooltipInfoLayout: React.FC<IProps> = ({ children }) => {
    return (
        <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
            <div className="tooltip-info">
                {children}
            </div>
        </FontBody2>
    );
}

export default TooltipInfoLayout;
